/******************************************************************************
 * App configuration
 *****************************************************************************/
export const APP_NAME = "Ableseportal Stadtwerke Norderstedt";
export const APP_SHORT_NAME = "Ableseportal";
export const APP_DESCRIPTION =
    "Melden Sie uns einfach online Ihre Zählerstände - schnell, bequem, sicher.";
export const CLIENT_FULL = "Stadtwerke Norderstedt";
export const CLIENT_SHORT = "Stadtwerke Norderstedt";
export const FALLBACK_PRECOMMA_DIGITS = 7;
export const URLS = {
    website: "https://www.stadtwerke-norderstedt.de",
    privacy: "https://www.stadtwerke-norderstedt.de/datenschutz",
    imprint: "https://www.stadtwerke-norderstedt.de/impressum",
};
export const LENGTH_IMPLAUSIBLE_REASON_OTHER = 200;
export const ERROR_MESSAGES = {
    error429: "😡 Zuviele Anfragen. Bitte versuchen Sie es in Kürze erneut.",
    error500:
        "😓 Beim Verarbeiten Ihrer Anfrage ist ein Fehler aufgetreten. Bitte kontaktieren Sie unseren Kundenservice.",
};
